import { ErrorResponse } from '@/types/common.types'

const SWEDISH_ERRORS = {
  BAD_INFORMATION: 'Vänligen fyll i de obligatoriska fälten.',
  ADDRESS_DOESNT_EXIST: 'Vi kan inte hitta din angivna adress. Vänligen kontakta <a href="/kundtjanst">kundtjänst</a>.',
  AREA_DOESNT_EXIST: 'Vi kan inte hitta din angivna adress. Vänligen kontakta <a href="/kundtjanst">kundtjänst</a>.',
  CREDIT_CHECK_WRONG_SSN: 'Vi lyckades inte att genomföra din kreditbedömning. Vänligen kontrollera att du angivit rätt personnummer.',
  CREDIT_CHECK_ERROR: 'Vi lyckades inte att genomföra din kreditbedömning. Vänligen försök igen eller kontakta <a href="/kundtjanst">kundtjänst</a>.',
  COULD_NOT_GENERATE_PDF: 'Ett fel uppstod vid signering av ditt avtal. Vänligen försök igen eller kontakta <a href="/kundtjanst">kundtjänst</a>.',
  SIGNING_REJECTED: 'Ett fel uppstod vid signering av ditt avtal. Vänligen försök igen eller kontakta <a href="/kundtjanst">kundtjänst</a>.',
  SIGNING_ERROR: 'Ett fel uppstod vid signering av ditt avtal. Vänligen försök igen eller kontakta <a href="/kundtjanst">kundtjänst</a>.',
  TECHNICAL_ERROR: 'Ett fel uppstod med din beställning. Vänligen försök igen eller kontakta <a href="/kundtjanst">kundtjänst</a>.'
}

export const ERROR_TAG_TO_MESSAGE: Record<string, string> = {
  'InterestPostUnauthorized': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'InterestPostAddressNotFound': SWEDISH_ERRORS.ADDRESS_DOESNT_EXIST,
  'InterestPostValidation': SWEDISH_ERRORS.BAD_INFORMATION,
  'InterestPostAreaNotFound': SWEDISH_ERRORS.AREA_DOESNT_EXIST,
  'InterestPostCustomerRegistered': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'InterestPostNotInterestFlow': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'InterestPostCustomerNotFound': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'PostUnauthorized': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'PostAddressNotFound': SWEDISH_ERRORS.ADDRESS_DOESNT_EXIST,
  'PostValidation': SWEDISH_ERRORS.BAD_INFORMATION,
  'PostAreaNotFound': SWEDISH_ERRORS.AREA_DOESNT_EXIST,
  'PostInterestFlow': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'PostSergelCreditCheckFailed': SWEDISH_ERRORS.CREDIT_CHECK_ERROR,
  'PostSergelWrongSsn': SWEDISH_ERRORS.CREDIT_CHECK_WRONG_SSN,
  'PostSergelUnknownError': SWEDISH_ERRORS.CREDIT_CHECK_ERROR,
  'PostTemplateNotFound': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'PostGeneratePdfFailed': SWEDISH_ERRORS.COULD_NOT_GENERATE_PDF,
  'PostVerifiedLoginFailed': SWEDISH_ERRORS.SIGNING_ERROR,
  'PostVerifiedEnvelopeNotFound': SWEDISH_ERRORS.SIGNING_ERROR,
  'PostVerifiedSignLinkNotFound': SWEDISH_ERRORS.SIGNING_ERROR,
  'PostCampaignNotFound': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'PostVerifiedNotActiveInArea': SWEDISH_ERRORS.SIGNING_ERROR,
  'PostCustomerNotFound': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'GetUnauthorized': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'GetAddressNotFound': SWEDISH_ERRORS.ADDRESS_DOESNT_EXIST,
  'GetAreaNotFound': SWEDISH_ERRORS.AREA_DOESNT_EXIST,
  'GetStatusUnauthorized': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'GetStatusValidation': SWEDISH_ERRORS.BAD_INFORMATION,
  'GetStatusCustomerNotFound': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'GetStatusVerifiedEnvelopeId': SWEDISH_ERRORS.SIGNING_ERROR,
  'GetStatusVerifiedLoginFailed': SWEDISH_ERRORS.SIGNING_ERROR,
  'GetStatusVerifiedRejected': SWEDISH_ERRORS.SIGNING_REJECTED,
  'GetStatusVerifiedEnvelopeStatus': SWEDISH_ERRORS.SIGNING_ERROR,
  'GetStatusVerifiedEnvelopeNotFound': SWEDISH_ERRORS.SIGNING_ERROR,
  'GetAddressUnauthorized': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'GetAddressValidation': SWEDISH_ERRORS.BAD_INFORMATION,
  'GetApartmentUnauthorized': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'GetApartmentValidation': SWEDISH_ERRORS.BAD_INFORMATION,
  'CommonInterestUnauthorized': SWEDISH_ERRORS.TECHNICAL_ERROR,
  'CommonInterestValidation': SWEDISH_ERRORS.BAD_INFORMATION
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const resolveToftaException = (error: any): string | null => {
  const data: ErrorResponse = error.response.data

  if (!data) {
    return null
  }

  if (ERROR_TAG_TO_MESSAGE[data.Tag]) {
    return ERROR_TAG_TO_MESSAGE[data.Tag]
  } else if (data.Message) {
    return data.Message
  }

  return null
}
